export { UserEditService } from './providers/user-edit.service';
